import Chart from 'chart.js/auto';

const LineChart = {
  mounted() {
    const ctx = this.el;
    const chartData = JSON.parse(this.el.dataset.chartData);
    const weekLabels = JSON.parse(this.el.dataset.weekLabels);

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: weekLabels,
        datasets: chartData.datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false // We handle title in HTML
          },
          legend: {
            display: true,
            position: 'bottom'
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            }
          },
          x: {
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }
        },
        elements: {
          line: {
            tension: 0.4
          },
          point: {
            radius: 4,
            hoverRadius: 6
          }
        }
      }
    });
  },

  updated() {
    const chartData = JSON.parse(this.el.dataset.chartData);
    const weekLabels = JSON.parse(this.el.dataset.weekLabels);

    this.chart.data.labels = weekLabels;
    this.chart.data.datasets = chartData.datasets;
    this.chart.update();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};

export default LineChart;